export default function createFunctionContext(initialValue) {
    var context = {
        value: initialValue,
    };
    var useProvider = createProviderHook(context);
    var useSelector = createSelectorHook(context);
    var useClear = createClearHook(context);
    return [useProvider, useSelector, useClear];
}
function createClearHook(context) {
    return function () {
        context.value = undefined;
    };
}
function createProviderHook(context) {
    return function (value) {
        context.value = value;
    };
}
function createSelectorHook(context) {
    return function (select) {
        if (select === void 0) { select = function (value) { return value; }; }
        return select(context.value);
    };
}
